import { atom } from "jotai";

export const tareaSeleccionadaIdAtom = atom(undefined);
export const tareaPendienteSeleccionadaAtom = atom(undefined);
export const tareasPendientesAtom = atom([]);
export const visibleModalFirmarAtom = atom(false);
export const datosFormularioAtom = atom(undefined);
export const formInstanceAtom = atom(undefined);